import { Link } from "react-router-dom";
import {Plus, Edit, Delete} from 'react-feather'
import { useContext, useState, useEffect } from "react";
import { appContext } from "../Context/appContext";
import { api } from "../helpers";
import { access, baseURL, MAIN_COLOR, path } from "../constants";
import Loader from "../Components/Loader";

export default function Tenants(){
    const {toggleATenant, showAddTenant, showMessage, setConfirm} = useContext(appContext)
    const [tenants, setTenants] = useState([])
    const [loading, setLoading] = useState(true)

    const fetchTenants = () => {
        setLoading(true)
        api.get(path.tenant).then(response => {
            const data = response.data
            if(data.success){
                setTenants(data.tenants)
            } else showMessage('Something went wrong', true)
        }).catch(e => showMessage('Something went wrong', true))
        .finally(() => setLoading(false))
    }

    useEffect(() => {
        if(!showAddTenant.visible) fetchTenants()
    }, [showAddTenant])

    // const deleteUser = (id) => {
    //     return function(){
    //         return api.delete(path.user, {
    //             data: {id}}
    //         ).then(r => {
    //             setUsers(m => m.filter(i => i.id != id))
    //             showMessage('User deleted', false)
    //         }).catch(e => showMessage('Something went wrong', true))
    //         .finally(() => setLoading(false))
    //     }
    // }

    return (
        <div className='flex flex-col flex-1 overflow-auto p-6 gap-6'>
        <button onClick={() => toggleATenant()} className='self-end bg-main px-4 p-2 rounded-sm font-bold  text-white flex items-center gap-2 hover:bg-darker transition-all border-none'>
            Create Tenant
            <Plus color="#ffffff" size={18} />
        </button>
        <p className='text-[16px] uppercase font-bold'>Tenants</p>
        <div className='overflow-y-auto flex-1 rounded-md bg-white p-0 flex flex-col'>
        <table className='w-full'>
            <thead>
                <tr>
                    <th>
                        Short Name
                    </th>
                    <th>
                        Long Name
                    </th>
                    <th>
                        Category
                    </th>
                    <th>
                        Phone Number
                    </th>
                    <th>
                        Headquarter
                    </th>
                    <th>
                        Representative
                    </th>
                    <th>
                        Rep. Phone Number
                    </th>
                    <th>
                        Plan
                    </th>
                    <th>
                        Features
                    </th>
                    <th>
                        Billing Cycle
                    </th>
                    <th>
                        Next Payment Due
                    </th>
                    <th>
                        Subscription Start
                    </th>
                    <th>
                        Subscription End
                    </th>
                    <th>
                        Created At
                    </th>
                    <th>
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody>
                {tenants.map(tenant => (
                    <tr>
                         <td className='pr-6 text-left'>
                             <img className='max-w-[40px] h-40px] inline object-contain' src={baseURL + path.uploads + tenant.logo} />
                             <span className='ml-2 '>{tenant.short_name}</span>
                        </td>
                         <td>{tenant.long_name}</td>
                         <td>{tenant.category?.replace('-', ' ')}</td>
                         <td>{tenant.phone_number}</td>
                         <td>{tenant.headquarter}</td>
                         <td>{tenant.rep_name}</td>
                         <td>{tenant.rep_phone}</td>
                         <td>{tenant.plan}</td>
                         <td>{tenant.features}</td>
                         <td>{tenant.billing_cycle}</td>
                         <td>{tenant.next_payment_due}</td>
                         <td>{tenant.subscription_start}</td>
                         <td>{tenant.subscription_end}</td>
                         <td>{tenant.createdAt?.split('.')[0]}</td>
                         <td className='flex items-center justify-center'>
                             <button onClick={() => toggleATenant(tenant)} className='border-none bg-none'>
                                 <Edit color='#000000' size={20} />
                             </button>
                             {/* <button onClick={() => setConfirm({
                                 visible: true,
                                 action: deleteUser(user.id)
                                 }) } className='border-none bg-none ml-3'>
                                 <Delete color="#ff0000" size={20} />
                             </button> */}
                         </td>
                    </tr>
                ))}
            </tbody>
        </table>
        {(!loading && !tenants.length) && <h4 className='text-center mt-4'>No Data.</h4>}
        <Loader text={null} loading={loading} color={MAIN_COLOR} style={{marginTop: 20, alignSelf: 'center'}} />
        </div>
    </div>
    )
}

// function UserAccess({setAccess, data, fetchUsers}){
//     const [userAccess, setUserAccess] = useState(data.access?.split(',')?.filter(f=>f) || [])
//     const [loading, setLoading] = useState(false)
//     const {showMessage} = useContext(appContext)

    
//     const saveAccess = () => {
//         setLoading(true)
//         api.put(path.user, {
//             id: data.id,
//             access: userAccess
//         }).then(response => {
//             let data = response.data
//             if(data.success) {
//                 showMessage('Success')
//                 fetchUsers()
//                 setAccess(false)
//             }
//             else showMessage('Something went wrong!')
//         }).finally(() => setLoading(false))
//     }
//     return (
//         <div className='fixed inset-0 flex items-center justify-center bg-[#00000080] z-[99999]'>
//             <div className='flex flex-col gap-6 p-4 bg-white p-6 max-md:p-2 max-md:py-4 rounded-md'>
//                 <h2 className="self-center text-[25px] font-bold max-md:text-[20px]">User Access</h2>
//                 <div className='grid grid-cols-3 max-md:grid-cols-2 gap-4 self-center'>
//                     {Object.values(access).map(acc => (
//                         <div className='flex items-center gap-2'>
//                             <input type='checkbox' onChange={e => {
//                                 if(e.target.checked) setUserAccess(a => [...a, acc])
//                                 else setUserAccess(a => a.filter(value => value != acc))
//                             }} id={acc} checked={userAccess?.includes(acc)} />
//                             <label className='select-none text-sm' for={acc}>{acc}</label>
//                         </div>
//                     ))}
//                 </div>
//                 <div className='flex justify-center gap-6'>
//                     <button onClick={saveAccess} className='py-2 px-8 font-bold text-[20px] bg-main text-white self-center'>
//                         <Loader text={'Save'} loading={loading} />                        
//                     </button>
//                     <button onClick={() => setAccess(false)} className='py-2 px-8 font-bold text-[20px] border-main border-[2px] text-black self-center' type='submit'>Cancel</button>
//                 </div>
//             </div>
//         </div>
//     )
// }